import { Link, useLocation } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { motion } from "framer-motion";

export default function FloatingQuote() {
  const location = useLocation();
  if (location.pathname === "/quote") return null;

  return (
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 1, type: "spring", stiffness: 200 }}
      className="fixed bottom-6 right-6 z-40"
    >
      <Link
        to="/quote"
        data-testid="floating-quote-btn"
        className="flex items-center gap-2 bg-[#FF5722] text-white px-5 py-3 shadow-lg shadow-[#FF5722]/20 hover:bg-[#E64A19] transition-all duration-200 group"
      >
        <MessageSquare size={18} />
        <span className="font-semibold text-sm hidden sm:inline">Request Quote</span>
      </Link>
    </motion.div>
  );
}
